import { formatMoney } from "../../utils/amount"
import { resolveSavings } from './feeDisplay'
// The server sends this unclamped, so a flat client whose fee exceeds their debt arrives as a
// negative. Same helper the Add Contact Review uses, so the two screens agree (Yulia, M4-save).

const SubStatistics = ({ statisticsData }) => (
  <div className="flex py-4">
    <div className="flex pr-3 gap-3 border-r-2 border-dashed border-divider">
      <span className="text-[12px]">Total Debts:</span>
      <span
        className="text-[12px] font-bold">{formatMoney(statisticsData?.totalCreditProfiles || 0)}</span>
    </div>
    <div className="flex px-3 gap-3 ">
      <span className="text-[12px]">Total Fees:</span>
      <span
        className="text-[12px] font-bold">{formatMoney(statisticsData?.totalFees || 0)}</span>
    </div>
    <div className="flex px-3 gap-3 ">
      <span className="text-[12px]">Savings:</span>
      <span
        className="text-[12px] font-bold">{formatMoney(resolveSavings({ enrolledDebt: statisticsData?.savings, programCost: 0 }))}</span>
    </div>
  </div>
)

export default SubStatistics
